// extracted by mini-css-extract-plugin
export default {"adminPage":"Admin_adminPage__Abqu0","panel":"Admin_panel__cnYHV","dashboard":"Admin_dashboard__n1Dbj"};